import 'leaflet/dist/leaflet.css';

import { FC, memo, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import FourZeroFourComponent from 'src/components/FourZeroFourComponent';
import LicenseContext from 'src/contexts/LicenseContext';
import { DateModel } from 'src/models/DateModel';
import { normalizePlanningEndOn } from 'src/utils/planningDateRange.util';

import Component from './V3Plans/Component';

const V3Plans: FC = memo(() => {
  const { startOn, endOn } = useParams();
  const context = useContext(LicenseContext);
  const navigate = useNavigate();

  const [unit, setUnit] = useState<string | undefined>(undefined);
  const [customInputFields, setCustomInputFields] = useState<string[]>([]);
  const [activateConstraintLoadAfterNotCleared, setActivateConstraintLoadAfterNotCleared] = useState<boolean>(false);
  const [loadAfterInitialStock, setLoadAfterInitialStock] = useState<boolean>(false);

  useEffect(() => {
    if (!context.config?.on) return;
    if (!context.config?.unit) return;

    setUnit(context.config.unit);
    setCustomInputFields(context.config.custom_input_fields);
    setActivateConstraintLoadAfterNotCleared(context.config.activate_constraint_load_after_not_cleared);
    setLoadAfterInitialStock(context.config.load_after_initial_stock);

    if (startOn) {
      const paramsOnModel = new DateModel(startOn);
      const { endOn: normalizedEndOn, changed } = normalizePlanningEndOn(startOn, endOn);
      if (!changed) return;

      if (paramsOnModel.isValid()) {
        void navigate(`/plans/${paramsOnModel.toString()}/${normalizedEndOn}`);
        return;
      }
    }

    const configOnModel = new DateModel(context.config.on);

    if (configOnModel.isValid()) {
      void navigate(`/plans/${configOnModel.toString()}/${configOnModel.toString()}`);
      return;
    }

    void navigate('/404');
  }, [startOn, endOn, context]);

  if (!startOn) return <FourZeroFourComponent />;

  return (
    <Component
      startOn={startOn}
      endOn={endOn}
      unit={unit}
      customInputFields={customInputFields}
      activateConstraintLoadAfterNotCleared={activateConstraintLoadAfterNotCleared}
      loadAfterInitialStock={loadAfterInitialStock}
    />
  );
});

export default V3Plans;
